/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type PdpSharedContactDealerButton_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpSharedShippingInfoLink_user$ref: FragmentReference;
export type PdpSharedShippingInfoLink_user = {|
  +canRequestShippingQuotePermission: ?boolean,
  +profile: ?{|
    +email: ?string
  |},
  +authMetadata: ?{|
    +emailOnly: ?boolean
  |},
  +$fragmentRefs: PdpSharedContactDealerButton_user$ref,
  +$refType: PdpSharedShippingInfoLink_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpSharedShippingInfoLink_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedContactDealerButton_user",
      "args": null
    },
    {
      "kind": "ScalarField",
      "alias": "canRequestShippingQuotePermission",
      "name": "hasPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_REQUEST_SHIPPING_QUOTE",
          "type": "String!"
        }
      ],
      "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "authMetadata",
      "storageKey": null,
      "args": null,
      "concreteType": "UserExistsMetadataType",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "emailOnly",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'e02e513cbf0b768d3d1ab1c60754c140';
module.exports = node;
